import React from 'react';
import {
  Box,
  Heading,
  Input,
  VStack,
  Text,
  Link,
  Divider,
  List,
  ListItem,
} from '@chakra-ui/react';

const GetHelpPage = () => {
  return (
    <Box p={8}  minH="100vh">
      <VStack spacing={6} align="start" width="100%">
        <Heading as="h1" size="2xl" textAlign="left" width="100%">
          Get Help
        </Heading>
        <Input
          placeholder="FAQs, Videos, Documentation and Forum Posts"
          size="lg"
          bg="white"
          boxShadow="sm"
          width="100%"
        />
        <Divider width="100%" />

        <Box width="100%">
          <Heading as="h2" size="lg" mb={4} textAlign="left">
            General
          </Heading>
          <List spacing={3} textAlign="left">
            <ListItem>How do I create a job listing?</ListItem>
            <ListItem>How can I apply for a job?</ListItem>
            <ListItem>What qualifications are needed for medical jobs?</ListItem>
            <ListItem>How do I update my profile?</ListItem>
            <ListItem>Can I save job searches?</ListItem>
            <ListItem>How do I contact support?</ListItem>
          </List>
        </Box>

        <Box width="100%">
          <Heading as="h2" size="lg" mb={4} textAlign="left">
            Quick Links
          </Heading>
          <VStack align="start" spacing={3} width="100%">
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Join the Community
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Read Documentation & Guides
            </Link>
            <Link href="#" color="blue.500" textAlign="left" width="100%">
              Hire an Expert
            </Link>
          </VStack>
        </Box>
      </VStack>
    </Box>
  );
};

export default GetHelpPage;